import Cookies from 'js-cookie';
import { updateSearch, getQuery } from './querystring';
import { day8Constants } from 'day8-react';
import history from '../history';
import Week from '../components/Filters/components/filters/Week';
import BoatYear from '../components/Filters/components/filters/BoatYear';
import BoatCabins from '../components/Filters/components/filters/BoatCabins';
import BoatSize from '../components/Filters/components/filters/BoatSize';
import Capacity from '../components/Filters/components/filters/Capacity';
import Hull from '../components/Filters/components/filters/Hull';
import Amenities from '../components/Filters/components/filters/Amenities';
import Marina from '../components/Filters/components/filters/Marina';
import Destination from '../components/Filters/components/filters/Destination';
import Year from '../components/Filters/components/filters/Year';
import Extras from '../components/Filters/components/filters/Extras';
import Crew from '../components/Filters/components/filters/Crew';
import CabinsCrewFilter from '../components/Filters/components/filters/CabinsCrewFilter';
import BookingTypeFilter from '../components/Filters/components/filters/BookingTypeFilter';
import { getPricePerPerson } from './pricing';
import { maxCapacityCrew } from './crew';
import { eventGA } from './analytics';
import { CAPACITY, FILTERS } from '../constants';
import Package from '../components/Filters/components/filters/Package';
import CountryFilter from '../components/Filters/components/filters/CountryFilter';
import FestivalFilter from '../components/Filters/components/filters/FestivalFilter';
import LastMinuteFilter from '../components/Filters/components/filters/LastMinuteFilter';
import DealsFilter from '../components/Filters/components/filters/DealsFilter';
import { getFeaturedData, isFeaturedWeek } from './week';

export const updateSelectedYachtTypes = selectedYachtTypes => selectedYachtTypes.reduce(
  (result, item) => {
    result[item] = true;
    return result;
  },
  {
    0: false,
    1: false,
    2: false,
    3: false,
    4: false
  }
);

export const markBestValueYacht = yachts => {
  if (!yachts.length) {
    return [];
  }
  // 1. reset bestValue because when you updated some of the filters it kept previous bestValue there
  yachts = yachts.map(y => ({ ...y, bestValue: false }));
  const cheapestYachtPrice = yachts.reduce(
    (min, b) => Math.min(min, getPricePerPerson(b, maxCapacityCrew(b.boat.capacity))),
    getPricePerPerson(yachts[0], maxCapacityCrew(yachts[0].boat.capacity))
  );
  const cheapestYachtIndex =
        yachts.findIndex(y => getPricePerPerson(y, maxCapacityCrew(y.boat.capacity)) === cheapestYachtPrice);
  if (cheapestYachtIndex > 0) {
    yachts[cheapestYachtIndex].bestValue = true;
  }
  return yachts;
};

export const sortYachts = (sortBy, yachts) => {
  let sortedYachts = null;
  switch (sortBy) {
  case 1: {
    // This is very cool algorithm that sorts yachts by certain criteria
    // Emma wants to figure it out and update later so leaving it here for now commented out
    // For now will jsut keep the cheapest sliced first and rest order by newest
    // sortedYachts = yachts.sort((a, b) => {
    //   const aMaxGuests = a.boat.capacity - 1;
    //   const bMaxGuests = b.boat.capacity - 1;
    //   const aScore = calculateYachtScore(a, aMaxGuests);
    //   const bScore = calculateYachtScore(b, bMaxGuests);
    //   if (aScore < bScore) {
    //     return 1;
    //   }
    //   if (aScore > bScore) {
    //     return -1;
    //   }
    //   return 0;
    // });
    // sortedYachts = yachts.sort((a, b) =>
    //   b.featured - a.featured ||
    //       getPricePerPerson(a, maxCapacityCrew(a.boat.capacity)) - getPricePerPerson(b, maxCapacityCrew(b.boat.capacity)));
    const cheapestYachtIndex = yachts.findIndex(y => y.bestValue);
    if (cheapestYachtIndex > 0) {
      const cheapestYacht = yachts.splice(cheapestYachtIndex, 1)[0];
      yachts.splice(0, 0, cheapestYacht);
    }
    sortedYachts = [
      yachts[0], // Keep the first yacht as the cheapest one
      ...yachts.slice(1).sort((a, b) => {
        // Sort by featured (descending), then by price (ascending), then by destination.priority (descending)
        if (b.featured !== a.featured) {
          return b.featured - a.featured;
        }
        if (a.price !== b.price) {
          return a.price - b.price;
        }
        return b.destinationId - a.destinationId;
      })
    ];
    if (yachts.length < 1) {
      sortedYachts = yachts;
    }
    break;
  }
  case 2:
    sortedYachts = yachts.sort((a, b) =>
      getPricePerPerson(a, maxCapacityCrew(a.boat.capacity)) - getPricePerPerson(b, maxCapacityCrew(b.boat.capacity)));
    break;
  case 3:
    sortedYachts = yachts.sort((a, b) =>
      getPricePerPerson(b, maxCapacityCrew(b.boat.capacity)) - getPricePerPerson(a, maxCapacityCrew(a.boat.capacity)));
    break;
  case 4:
    sortedYachts = yachts.sort((a, b) => b.boat.year - a.boat.year);
    break;
  case 5:
    sortedYachts = yachts.sort((a, b) => a.boat.year - b.boat.year);
    break;
  case 6:
    sortedYachts = yachts.sort((a, b) => b.featured - a.featured || a.price_num - b.price_num);
    break;
  default:
    sortedYachts = yachts;
  }
  return sortedYachts;
};

export const filterComponents = {
  Week,
  BoatYear,
  BoatCabins,
  BoatSize,
  Capacity,
  Hull,
  Amenities,
  Marina,
  Destination,
  Year,
  Extras,
  Crew,
  CabinsCrewFilter,
  BookingTypeFilter,
  Package,
  CountryFilter,
  FestivalFilter,
  LastMinuteFilter,
  DealsFilter
};

export const getSelectedFilters = location => {
  const query = getQuery(location);
  const {
    minPrice,
    maxPrice,
    favourites,
    cabinBookingType,
    lastMinute,
    deals
  } = query;
  let {
    hullType,
    minCapacity,
    maxCapacity,
    marina,
    amenities,
    weekFilter,
    weeks, // this is weeks from week select step
    destinationFilter,
    dest, // this is dest from destination select step
    yearFilter,
    year, // this is year from week select step
    boatYear,
    boatCabins,
    boatSize,
    extras,
    // boys,
    // girls,
    // hostess,
    cabinType,
    soloType,
    packageFilter,
    countryFilter,
    festivalFilter,
    month // used primarily to get month from funnel modal
  } = query;
  let searchToUpdate = {};
  if (!Array.isArray(hullType)) {
    hullType = hullType ? [hullType] : [];
  }
  if (!Array.isArray(marina)) {
    marina = marina ? [marina] : [];
  }
  if (!Array.isArray(amenities)) {
    amenities = amenities ? [amenities] : [];
  }
  if (!Array.isArray(extras)) {
    extras = extras ? [extras] : [];
  }
  if (!Array.isArray(boatYear)) {
    boatYear = boatYear ? [boatYear] : [];
  }
  if (!Array.isArray(boatCabins)) {
    boatCabins = boatCabins ? [boatCabins] : [];
  }
  if (!Array.isArray(boatSize)) {
    boatSize = boatSize ? [boatSize] : [];
  }
  if (!Array.isArray(cabinType)) {
    cabinType = cabinType ? [cabinType] : [];
  }
  if (!Array.isArray(packageFilter)) {
    packageFilter = packageFilter ? [packageFilter] : [];
  }
  if (!Array.isArray(countryFilter)) {
    countryFilter = countryFilter ? [countryFilter] : [];
  }
  if (!Array.isArray(festivalFilter)) {
    festivalFilter = festivalFilter ? [festivalFilter] : [];
  }
  if (!Array.isArray(month)) {
    month = month ? [month] : [];
  }
  if (!Array.isArray(soloType)) {
    soloType = soloType ? [soloType] : [];
  }
  // `weeks` and `dest` come from the destination/week select steps and mean the same thing as
  // weekFilter/destinationFilter, so they bridge across. Both are already normalised to a flat
  // array by this point - wrapping them again produced [['50']], which no consumer's
  // `.includes('50')` could ever match, so any URL carrying a legacy param emptied the list.
  if (!Array.isArray(weekFilter)) {
    weekFilter = weekFilter ? [weekFilter] : [];
    if (!Array.isArray(weeks)) {
      weeks = weeks ? [weeks] : [];
    }
    if (!weekFilter.length && weeks?.length) {
      weekFilter = weeks;
    }
  }
  if (!Array.isArray(destinationFilter)) {
    destinationFilter = destinationFilter ? [destinationFilter] : [];
    if (!Array.isArray(dest)) {
      dest = dest ? [dest] : [];
    }
    if (!destinationFilter.length && dest?.length) {
      destinationFilter = dest;
    }
  }
  // `year` deliberately does NOT bridge into yearFilter: it is the *financial* year, and identifies
  // a week alongside `weeks` (see getWeeksForYear), whereas every yearFilter consumer compares
  // against the calendar year of the week's begin date. The two differ whenever a week straddles
  // new year (Mexico week 50 is financial 2027 but begins 2026-12-05), so bridging one to the other
  // hid exactly those weeks. yearFilter is only ever set from a calendar year - by the Year filter,
  // by crewFinderLink, or by the single-season defaults.
  if (!Array.isArray(yearFilter)) {
    yearFilter = yearFilter ? [yearFilter] : [];
  }
  if (!minCapacity) {
    minCapacity = CAPACITY.MIN;
  }
  if (!maxCapacity) {
    maxCapacity = CAPACITY.MAX;
  }

  if (Object.keys(searchToUpdate).length) {
    history.push({
      pathname: location.pathname,
      search: updateSearch(location, searchToUpdate)
    });
  }
  let countOfFiltersSelected = 0;
  if (hullType.length > 0) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (marina.length > 0) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (amenities.length > 0) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (extras.length > 0) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (boatYear.length > 0) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (boatCabins.length > 0) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (boatSize.length > 0) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (weekFilter.length > 0) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (countryFilter.length > 0) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (festivalFilter.length > 0) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (destinationFilter.length > 0) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (month.length > 0) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (minPrice != null) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (maxPrice != null) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (favourites != null) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (lastMinute != null) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (deals != null) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (+minCapacity !== CAPACITY.MIN) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (+maxCapacity !== CAPACITY.MAX) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (packageFilter.length > 0) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }
  if (yearFilter.length > 0) {
    countOfFiltersSelected = countOfFiltersSelected + 1;
  }

  return {
    hullType,
    minCapacity,
    maxCapacity,
    marina,
    amenities,
    weekFilter,
    destinationFilter,
    yearFilter,
    boatYear,
    boatCabins,
    boatSize,
    minPrice,
    maxPrice,
    extras,
    favourites,
    lastMinute,
    deals,
    month,
    cabinBookingType,
    cabinType,
    soloType,
    countryFilter,
    festivalFilter,
    countOfFiltersSelected,
    packageFilter,
    // adding here query params which is selection from confirm step to be able to clear them now too with new funnel
    weeks,
    dest,
    year
  };
};

export const isFilterSelected = (location, filter, value) => {
  const selectedFilters = getSelectedFilters(location);
  const selectedFilter = selectedFilters[filter];
  if (!selectedFilter) {
    console.warn(`${filter} is not valid filter`);
    return false;
  }
  if (Array.isArray(selectedFilter)) {
    return selectedFilter.includes(`${ value}`);
  }

  return false;
};

export const onFilterSelect = (location, dispatch, filterAction, filter, value) => {
  const selectedFilters = getSelectedFilters(location);
  const selectedFilter = selectedFilters[filter];
  // if (!selectedFilter) {
  //   console.warn(`${filter} is not valid filter`);
  //   return null;
  // }
  let filteredValues = selectedFilter;
  // filtered values can be array or number or whatever, but if is array we need to either push to it selected value or filter it out
  const isFilteredValuesArray = Array.isArray(filteredValues);
  if (isFilteredValuesArray) {
    if (isFilterSelected(location, filter, value)) {
      filteredValues = filteredValues.filter(item => `${ item}` !== `${ value}`);
    } else {
      filteredValues.push(value);
    }
  } else {
    filteredValues = value;
  }
  const filteredValuesString = isFilteredValuesArray ? filteredValues.join(',') : `${ filteredValues}`;
  eventGA('Filters', `Changed ${filter} in filters`, filteredValuesString || 'none');
  Cookies.set(day8Constants.COOKIES.FILTER, JSON.stringify({ ...selectedFilters, [filter]: filteredValues }), { expires: 120 });
  history.push({
    pathname: location.pathname,
    search: updateSearch(location, { [filter]: filteredValues })
  });
  // here using location from history which was just updated
  dispatch(filterAction(history.location));
};

// Set several scalar filters at once in a single history push + dispatch. Used by the price slider so
// a min+max change doesn't fan out into two pushes / two dispatches. Reads current filters from the
// passed location, so callers can hold a stable (non-re-created) handler without going stale.
export const onFiltersSelect = (location, dispatch, filterAction, updates) => {
  const selectedFilters = getSelectedFilters(location);
  const changed = {};
  Object.keys(updates).forEach(filter => {
    const value = updates[filter];
    if (`${selectedFilters[filter] ?? ''}` !== `${value ?? ''}`) {
      changed[filter] = value;
    }
  });
  if (Object.keys(changed).length === 0) {
    return null;
  }
  Cookies.set(day8Constants.COOKIES.FILTER, JSON.stringify({ ...selectedFilters, ...changed }), { expires: 120 });
  history.push({
    pathname: location.pathname,
    search: updateSearch(location, changed)
  });
  // here using location from history which was just updated
  dispatch(filterAction(history.location));
};

export const setDefaultCabinsCrewFilter = () => {
  const selectedFilters = getSelectedFilters(history.location);
  const { cabinBookingType, cabinType, soloType, boys, girls } = selectedFilters;
  if (cabinBookingType && (!cabinType || cabinType.length < 1) && (!soloType || soloType.length < 1)) {
    // Here we can set default values for cabins crew only once and won't mess with user selector...
    const newCabinType = girls > boys ? ['girl'] : ['boy'];
    Cookies.set(day8Constants.COOKIES.FILTER, JSON.stringify({ ...selectedFilters, cabinType: newCabinType }), { expires: 120 });
    history.replace({
      pathname: history.location.pathname,
      search: updateSearch(history.location, {
        cabinType: newCabinType
      })
    });
  }};

export const clearFilters = (location, dispatch, filterAction) => {
  const selectedFilters = getSelectedFilters(location);
  Object.keys(selectedFilters).forEach(key => selectedFilters[key] = null);
  Cookies.remove(day8Constants.COOKIES.FILTER);
  history.push({
    pathname: location.pathname,
    search: updateSearch(location, selectedFilters)
  });
  // here using location from history which was just updated
  dispatch(filterAction(history.location));
};

export const clearFilter = (dispatch, filterAction, filter) => {
  const selectedFilters = getSelectedFilters(history.location);
  const filterValue = selectedFilters[filter];
  if (!filter || (Array.isArray(filterValue) ? !filterValue.length : !filterValue)) {
    return null;
  }
  Cookies.set(day8Constants.COOKIES.FILTER, JSON.stringify({ ...selectedFilters, [filter]: null }), { expires: 120 });
  history.push({
    pathname: history.location.pathname,
    search: updateSearch(history.location, { [filter]: null })
  });
  // here using location from history which was just updated
  dispatch(filterAction(history.location));
};

// Price is stored as two params (minPrice/maxPrice) — clear both in a single history push + dispatch.
export const clearPriceFilter = (dispatch, filterAction) => {
  const selectedFilters = getSelectedFilters(history.location);
  if (selectedFilters.minPrice == null && selectedFilters.maxPrice == null) {
    return null;
  }
  const cleared = { [FILTERS.MIN_PRICE]: null, [FILTERS.MAX_PRICE]: null };
  Cookies.set(day8Constants.COOKIES.FILTER, JSON.stringify({ ...selectedFilters, ...cleared }), { expires: 120 });
  history.push({
    pathname: history.location.pathname,
    search: updateSearch(history.location, cleared)
  });
  // here using location from history which was just updated
  dispatch(filterAction(history.location));
};

export const getSelectedCabinsCrewText = () => {
  const selectedFilters = getSelectedFilters(history.location);
  const cabinTypesCount = selectedFilters.cabinType?.length || 0;
  const soloTypesCount = selectedFilters.soloType?.length || 0;
  const selectedFilterText = `${cabinTypesCount ? `${cabinTypesCount} Full Cabin${cabinTypesCount > 1 ? 's' : ''}` : ''}${soloTypesCount ? `${cabinTypesCount ? ', ' : ''}${soloTypesCount} Shared Spot${soloTypesCount > 1 ? 's' : ''}` : ''}`;
  return selectedFilterText;
};

export const getFestivalOptions = weeks => {
  const festivalOptions = [];
  if (!weeks.length) {
    return festivalOptions;
  }
  // handle original festivals:
  // 1. get all weeks and filter out festival weeks
  const originalFestivalWeeks = weeks.filter(week => !isFeaturedWeek(week));
  // 2. now that we have only original weeks, group them by destination country
  originalFestivalWeeks.forEach(week => {
    if (!festivalOptions.some(item => item.name === week.destination.name)) {
      festivalOptions.push({ name: week.destination.name, weekIds: [week.id] });
    } else {
      const index = festivalOptions.findIndex(item => item.name === week.destination.name);
      festivalOptions[index].weekIds.push(week.id);
    }
  });
  // Now identify festival options from constants - I need name and week IDs to select
  // there is possiblity we have multiple week IDs on one festival name so need to dedupe
  // also need to filter out the ones which are not available in all weeks
  // grouped by festival name, not destination: Rhythm & Waves runs in Croatia and Greece and is one option
  const priority = week => getFeaturedData(week)?.priority ?? Number.MAX_SAFE_INTEGER;
  const availableFestivalWeeks = weeks.filter(week => isFeaturedWeek(week)).sort((a, b) => priority(a) - priority(b));
  availableFestivalWeeks.forEach(week => {
    const name = getFeaturedData(week).featuredPill.title;
    if (!festivalOptions.some(item => item.name === name)) {
      festivalOptions.push({ name, weekIds: [week.id] });
    } else {
      const index = festivalOptions.findIndex(item => item.name === name);
      festivalOptions[index].weekIds.push(week.id);
    }
  });
  return festivalOptions;
};

// export const markBestValueBookingOption = (destinations, cabins, items) => {
//   if (!items.length) {
//     return [];
//   }
//   // 1. reset bestValue because when you updated some of the filters it kept previous bestValue there
//   items = items.map(y => ({ ...y, bestValue: false }));
//   const { cabinBookingType } = getSelectedFilters(history.location);
//   let cheapestItem = null;
//   let cheapestYachtIndex  = null;
//   if (cabinBookingType) {
//     const selectedCrewForFirstWeek = getCrewFromSelectedCabins(cabins, destinations, history.location, items[0].week, items[0].category.data.package.id);
//     const totalPriceForFirstWeek = getTotalPriceFromSelectedCabins(cabins, destinations, history.location, items[0].week, items[0].category.data.package.id);
//     cheapestItem = items.reduce(
//       (min, i) => {
//         const selectedCrew = getCrewFromSelectedCabins(cabins, destinations, history.location, i.week, i.category.data.package.id);
//         const totalPrice = getTotalPriceFromSelectedCabins(cabins, destinations, history.location, i.week, i.category.data.package.id);
//         if (!totalPrice) return min;
//         return Math.min(min, totalPrice / selectedCrew.total);
//       },
//       totalPriceForFirstWeek / selectedCrewForFirstWeek.total
//     );
//     cheapestYachtIndex =
//     items.findIndex(i => {
//       const selectedCrew = getCrewFromSelectedCabins(cabins, destinations, history.location, i.week, i.category.data.package.id);
//       const totalPrice = getTotalPriceFromSelectedCabins(cabins, destinations, history.location, i.week, i.category.data.package.id);
//       return totalPrice / selectedCrew.total === cheapestItem;
//     });
//   } else {
//     const selectedCrew = getSelectedCrew(destinations, history.location);
//     cheapestItem = items.reduce(
//       (min, i) => Math.min(min, getTotalStandardPricePerPerson(i.standardYachtWeek, i.week, selectedCrew)),
//       getTotalStandardPricePerPerson(items[0].standardYachtWeek,items[0].week, selectedCrew)
//     );
//     cheapestYachtIndex =
//     items.findIndex(i => getTotalStandardPricePerPerson(i.standardYachtWeek, i.week, selectedCrew) === cheapestItem);
//   }
//   if (cheapestYachtIndex > 0) {
//     items[cheapestYachtIndex].bestValue = true;
//   }
//   return items;
// };